export default function () {

  this.$langs.find('.menu-btn__langs').html($('.site-lang-links').html());
}
